class UrlService {
  static getBffUrl() {
    return localStorage.getItem('BFF_URL') || process.env.BFF_URL;
  }
}

export default UrlService;



// WEBPACK FOOTER //
// ./src/service/url.service.js